module.exports = __webpack_public_path__ + "static/media/katlesta.a83b78e3.jpg";